import * as yup from "yup";

export const ForgotPasswordSchema = yup.object({
  email: yup
    .string()
    .email("SpecifyEmail")
    .required("SpecifyValidEmail")
});

export type ForgotPasswordModel = yup.InferType<typeof ForgotPasswordSchema>;